import {
    PollResponse,
    PollResultsResponse,
    QuestionsResponse,
    TakerResultsResponse,
    TakerValidationResponse
} from "./responses.model";

export declare type TakerAppStateString =
    'ui-ready'  // UI reports on readiness then API starts initialization by loading config first
    | 'config'    // config is loaded
    | 'poll'      // poll is loaded
    | 'start'     // taker started poll
    | 'q-edit'    // taker enter responses
    | 'q-view'    // taker reviewing responses
    | 'taker-results' // taker results are loaded
    | 'poll-results'  // poll results are loaded
    ;

export class TakerAppStateContext {

    scriptId: string;          // script Id
    pollId: number;            // poll Id
    anonymous: boolean;        // anonymous access to poll
    token: string;             // session token for anonymous access

    pollLocalStartTime: number;    // used for timed polls to count/display time left for taking a poll.
                                   // The value is extracted from responses and adjusted to local time

    pollResponse: PollResponse;                    // poll
    questionsResponse: QuestionsResponse;          // questions
    validationResponse: TakerValidationResponse;   // validated responses
    takerResultsResponse: TakerResultsResponse;    // taker's responses and summary after final submit
    pollResultsResponse: PollResultsResponse;      // summary of poll results from all takers

    justSubmitted: boolean;    // one time flag indicating that taker results have just been submitted

    constructor(obj: any) {
        Object.assign(this, obj);
    }
}

export class TakerAppState {

    state: TakerAppStateString;
    context: TakerAppStateContext;

    constructor(state: TakerAppStateString, context?: any) {
        this.state = state;
        this.context = new TakerAppStateContext(context);
    }

    getPollLocalStartTime(): number {
        return this.context ? this.context.pollLocalStartTime : null;
    }
}
